// extracted by mini-css-extract-plugin
module.exports = {"lightCollapse":"LrvCollapse_lightCollapse__33C8d","darkCollapse":"LrvCollapse_darkCollapse__2Bjp2"};